import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";
export interface CommercialLeasingOpportunitiesTab {
  id: number;
  title: string;
  field_content_english: {
    data: {
      form: Record<string, any>;
      items: {
        tab?: {
          name: string;
          index: string;
        };
        body?: string;
      }[];
      map: {
        coordinates: {
          lat: number;
          lng: number;
        };
      };
      markup: string;
      inquiriesMarkup: string;
      addressMarkup: string;
      afterSubmitText: {
        thankYouText: string;
        backToFrom: string;
      };
      nextPage: {
        name: string;
        link: string;
      };
    };
    labelData: Record<string, any>;
  };
  field_content_malay: {
    data: {
      form: Record<string, any>;
      items: {
        tab?: {
          name: string;
          index: string;
        };
        body?: string;
      }[];
      map: {
        coordinates: {
          lat: number;
          lng: number;
        };
      };
      markup: string;
      inquiriesMarkup: string;
      addressMarkup: string;
      afterSubmitText: {
        thankYouText: string;
        backToFrom: string;
      };
      nextPage: {
        name: string;
        link: string;
      };
    };
    labelData: Record<string, any>;
  };
  field_content_mandarin: {
    data: {
      form: Record<string, any>;
      items: {
        tab?: {
          name: string;
          index: string;
        };
        body?: string;
      }[];
      map: {
        coordinates: {
          lat: number;
          lng: number;
        };
      };
      markup: string;
      inquiriesMarkup: string;
      addressMarkup: string;
      afterSubmitText: {
        thankYouText: string;
        backToFrom: string;
      };
      nextPage: {
        name: string;
        link: string;
      };
    };
    labelData: Record<string, any>;
  };
  field_page: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

const fetchData = async <T>(url: string): Promise<T> => {
  const response = await corporateCMSApi.get<T>(url);
  return response.data;
};

const createDataHook =
  <T>(key: string, url: string) =>
  (
    options?: UseQueryOptions<T, DefaultError, T, QueryKey>,
    queryClient?: QueryClient
  ): UseQueryResult<T, DefaultError> => {
    return useQuery<T, DefaultError, T, QueryKey>(
      {
        queryKey: [key],
        enabled: false,
        queryFn: () => fetchData<T>(url),
        refetchOnWindowFocus: false,
        ...options,
      },

      queryClient
    );
  };
const useCommercialLeasingOpportunitesTab = createDataHook<CommercialLeasingOpportunitiesTab[]>(
  "commercialLeasingOpportunities",
  `/api/page-content/all-fields?pageName=business/business-opportunities/commercial-leasing-opportunities`
);

export { useCommercialLeasingOpportunitesTab };
